<script lang="ts">
  import { environment } from '../stores/environment';
  import { telegram } from '../stores/telegram';

  let env = $state($environment);
  let tg = $state($telegram);

  $effect(() => {
    env = $environment;
    tg = $telegram;
  });
</script>

<div class="max-w-2xl mx-auto">
  <h1 class="text-3xl font-bold mb-6">Profile</h1>

  {#if env?.isTelegram && tg.isAvailable && tg.user}
    <!-- Telegram User Profile -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-6">
      <div class="flex items-center space-x-4 mb-4">
        {#if tg.user.photo_url}
          <img
            src={tg.user.photo_url}
            alt={tg.user.first_name}
            class="w-12 h-12 rounded-full"
          />
        {:else}
          <div class="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white text-2xl font-bold">
            {tg.user.first_name.charAt(0)}
          </div>
        {/if}

        <div>
          <h2 class="text-xl font-semibold">
            {tg.user.first_name}
            {#if tg.user.last_name}
              {tg.user.last_name}
            {/if}
          </h2>
          {#if tg.user.username}
            <p class="text-gray-600 dark:text-gray-400">@{tg.user.username}</p>
          {/if}
        </div>
      </div>

      <div class="border-t dark:border-gray-700 pt-4 space-y-2">
        <div class="flex justify-between">
          <span class="text-gray-600 dark:text-gray-400">User ID</span>
          <span class="font-medium">{tg.user.id}</span>
        </div>
        {#if tg.user.language_code}
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">Language</span>
            <span class="font-medium">{tg.user.language_code.toUpperCase()}</span>
          </div>
        {/if}
        {#if tg.webAppData}
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">Platform</span>
            <span class="font-medium">{tg.webAppData.platform}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">Theme</span>
            <span class="font-medium">{tg.webAppData.colorScheme}</span>
          </div>
        {/if}
      </div>
    </div>
  {:else}
    <!-- Generic Profile -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-6">
      <div class="flex items-center space-x-4 mb-4">
        <div class="w-12 h-12 rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center">
          <svg class="w-8 h-8 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>

        <div>
          <h2 class="text-xl font-semibold">Anonymous Reader</h2>
          <p class="text-gray-600 dark:text-gray-400">Local profile</p>
        </div>
      </div>

      <div class="border-t dark:border-gray-700 pt-4">
        <p class="text-gray-600 dark:text-gray-400 text-sm">
          Your reading data is stored locally on this device.
          To sync across devices, open Legere in Telegram.
        </p>
      </div>
    </div>
  {/if}

  <!-- Environment Info -->
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
    <h3 class="text-lg font-semibold mb-4">Environment</h3>
    <div class="space-y-2 text-sm">
      <div class="flex justify-between">
        <span class="text-gray-600 dark:text-gray-400">Platform</span>
        <span class="font-medium">{env?.displayName || 'Unknown'}</span>
      </div>
      <div class="flex justify-between">
        <span class="text-gray-600 dark:text-gray-400">Device Type</span>
        <span class="font-medium">{env?.isMobile ? 'Mobile' : 'Desktop'}</span>
      </div>
      {#if env?.isPWA}
        <div class="flex justify-between">
          <span class="text-gray-600 dark:text-gray-400">PWA</span>
          <span class="font-medium text-green-600">Installed</span>
        </div>
      {/if}
      {#if env?.isCapacitor}
        <div class="flex justify-between">
          <span class="text-gray-600 dark:text-gray-400">Native App</span>
          <span class="font-medium text-green-600">Yes</span>
        </div>
      {/if}
    </div>
  </div>
</div>
